<template>
<div>
    <div class="row">
        <div class="col-md-12">
            <base-crud :ref="'vehicle_modelsCrud'" :crudName="$t('Vehicle Models')" :newText="$t('Add')+ '  '+$t('New')" :table="table" :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true" :enableView="false" :enableReset="false" :dataForm="dataForm">
            </base-crud>
        </div>
    </div>
</div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
    data: function () {
        return {
            table: "vehicle_modelsTable",
            showMessageImport: false,
            vehicle_modelsCrud: {},
            pages: [],
            url: "",
            columns: [
                "id",
                "name",
                "vehicle_brand_id",
                "year",
                "status",
                "actions",
            ],
            tableData: ["id", "name", "vehicle_brand_id", "year", 'status'],
            optionsOrigin: {
                filterByColumn: true,
                debounce: 1000,
                filterable: ["id","name", "vehicle_brand_id", "year", "status"],
                pagination: {
                    chunk: 10,
                    dropdown: false,
                    nav: "scroll"
                },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: this.$t('id'),
                    name: this.$t('Name'),
                    vehicle_brand_id: this.$t('Vehicle Brand'),
                    year: this.$t('Year'),
                    status: this.$t('Status'),
                    actions: this.$t('action'),
                },

                texts: {
                    filterBy: this.$t('Filter'),
                    defaultOption: this.$t('Select'),
                },
                listColumns: {
                  status: [
                    {id: 1, text: this.$t('Active')},
                    {id: 0, text: this.$t('Inactive')}
                  ]
                },
                templates: {
                    status: function (h, row, index) {
                        return row.status == 1 ?
                            this.$t('Active') :
                            this.$t('Inactive')
                    },

                    vehicle_brand_id: function (h, row, index) {
                        return row.vehicle_brand ? row.vehicle_brand.name : ""
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};
                    let query = this.$parent.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["vehicle_brand"];

                    return axios.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "vehicle_models",
            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    computed: {
        options() {
            const headings = {
                id: this.$t('id'),
                name: this.$t('Name'),
                vehicle_brand_id: this.$t('Vehicle Brand'),
                year: this.$t('Year'),
                status: this.$t('Status'),
                actions: this.$t('action'),
            }

            const texts = {
                filterBy: this.$t('Filter'),
                defaultOption: this.$t('Select'),
            }
            return {
                ...this.optionsOrigin,
                texts,
                headings,
            }

        }

    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            let fileImport = document.getElementById("fileImport");

            fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

            return fd;
        },
        query: function (query) {
            let columns = {
                id: "id",
                name: "name",
                vehicle_brand_id: "vehicle_brand[name]",
                year: "year",
                status: "status"

            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
        openInput() {
            document.getElementById("fileImport").click();
        },
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}

.uploading-image {
    display: flex;
    border-radius: 10px;
    width: 100px;
    height: 100px;
}
</style>
